import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "card-header"
};
const _hoisted_2 = {
    key: 1,
    class: "empty-text"
};
const _hoisted_3 = { class: "date-label" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "doc-info" };
const _hoisted_6 = { class: "doc-company" };
const _hoisted_7 = { class: "doc-filename" };
const _hoisted_8 = { class: "doc-added" };
const _hoisted_9 = {
    key: 0,
    class: "doc-label"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecentDocuments',
    props: {
        documents: {},
        limit: {},
        card: { type: Boolean }
    },
    emits: ["doc-click", "view-more"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const sorted = computed(() => {
            return [...props.documents].sort((a, b) => new Date(b.createDateTime).getTime() - new Date(a.createDateTime).getTime());
        });
        const limitedGroups = computed(() => {
            const docs = props.limit ? sorted.value.slice(0, props.limit) : sorted.value;
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            const groups = [];
            const map = {};
            docs.forEach(doc => {
                const d = new Date(doc.createDateTime);
                d.setHours(0, 0, 0, 0);
                let label;
                if (d.getTime() === today.getTime())
                    label = 'Today';
                else if (d.getTime() === yesterday.getTime())
                    label = 'Yesterday';
                else
                    label = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
                if (!map[label]) {
                    map[label] = { dateLabel: label, docs: [] };
                    groups.push(map[label]);
                }
                map[label].docs.push(doc);
            });
            return groups;
        });
        const showViewAll = computed(() => {
            return props.card !== false && props.limit && props.documents.length > props.limit;
        });
        function formatDate(dateStr) {
            if (!dateStr)
                return '';
            const d = new Date(dateStr);
            return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_ctx.card ? 'recent-docs-card' : 'recent-docs-list')
            }, [
                (_ctx.card)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[1] || (_cache[1] = [
                        _createElementVNode("p", { class: "card-title" }, "Recently added", -1),
                        _createElementVNode("div", { class: "header-divider" }, null, -1)
                    ])))
                    : _createCommentVNode("", true),
                (limitedGroups.value.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, "No documents yet"))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedGroups.value, (group) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                        key: group.dateLabel
                    }, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(group.dateLabel) + " (" + _toDisplayString(group.docs.length) + ")", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.docs, (doc) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: doc.id,
                                class: "doc-row",
                                onClick: ($event) => (emit('doc-click', doc))
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(doc.company || doc.documentSubject), 1),
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(doc.documentName), 1),
                                    _createElementVNode("p", _hoisted_8, "Added " + _toDisplayString(formatDate(doc.createDateTime)), 1),
                                    (doc.documentSubject)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(doc.documentSubject), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("img", {
                                    src: require('@/assets/arrow-right.png'),
                                    class: "doc-arrow"
                                }, null, 8, _hoisted_10)
                            ], 8, _hoisted_4));
                        }), 128))
                    ], 64));
                }), 128)),
                (showViewAll.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "view-all-row",
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('view-more')))
                    }, [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "view-all-text" }, "View all", -1)),
                        _createElementVNode("img", {
                            src: require('@/assets/arrow-right.png'),
                            class: "view-all-arrow"
                        }, null, 8, _hoisted_11)
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
